


































import { Component, Vue, Prop, Ref } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'

@Component

export default class ComponenteBackofficeDataSolicitadaOperadora extends Vue {
  $refs!: { formDataSolicitacaoOperadora: any }

  @Prop({ default: false }) disabled: boolean

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  dataSolicitacaoOperadoraRules: any = {
    valid: false,
    dataReferenciaParaOperadora: [v => !!v || 'Campo obrigatório'],
  }

  get dataReferenciaParaOperadora() {
    const { cotacaoOperadorasExtraGrupo } = this.getBackofficeGlobalStore.solicitacao
    return cotacaoOperadorasExtraGrupo && cotacaoOperadorasExtraGrupo.dataReferenciaParaOperadora
      ? cotacaoOperadorasExtraGrupo.dataReferenciaParaOperadora
      : ''
  }

  set dataReferenciaParaOperadora(value: string | Date) {
    this.getBackofficeGlobalStore.setCotacaoOperadorasExtraGrupoDataReferenciaParaOperadora(value)
  }
}
